import './Nav.scss'

import { useFlags } from 'launchdarkly-react-client-sdk'
import { isReviewEnabled, isRiseEnabled } from 'lib/client/360-subscriptions'
import AuthContext from 'lib/context/AuthContext'
import SubContext from 'lib/context/SubContext'
import { SignOutReason } from 'lib/hooks/useAuth'
import useBridgeProfileValidation from 'lib/hooks/useBridgeProfileValidation'
import { isLoggedIn } from 'lib/util/self'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import TrainWithReach360Dialog from '../Dialog/TrainWithReach360Dialog'
import TrainWithReach360ErrorDialog from '../Dialog/TrainWithReach360ErrorDialog'
import NavItem from './NavItem'

const logoBackground = `url(${process.env.CDN_USER_CONTENT_URI}/assets/images/360_dashboard_logo.svg)`
const bridgeUrl = `https://${process.env.BRIDGE_DOMAIN}/api/heyokra/api/public/bridge`

function NavItemReach360() {
  const [ showReach360Dialog, setShowReach360Dialog ] = useState(false)
  const [ showReach360ErrorDialog, setShowReach360ErrorDialog ] = useState(false)

  const authContext = useContext(AuthContext)
  const { data, error } = useBridgeProfileValidation()
  const [t] = useTranslation()

  const onClickAuthorHandler = () => setShowReach360Dialog(true)
  const onClickErrorHandler = () => setShowReach360ErrorDialog(true)

  let href: string | undefined
  let onClick: ()=> void | undefined

  if (error) {
    if (error.response?.status === 401) {
      authContext.logout(SignOutReason.InvalidSession)

      return null
    } else {
      onClick = onClickErrorHandler
    }
  } else {
    if (!data || data.isAdminWithBridgeSubscription) {
      href = bridgeUrl
    } else if (data?.redirectToMarketingPage) {
      href = process.env.BRIDGE_LANDING_PAGE_URI
    } else {
      onClick = onClickAuthorHandler
    }
  }

  return (
    <>
      {showReach360Dialog && (
        <TrainWithReach360Dialog
          onRequestClose={() => setShowReach360Dialog(false)}
          url={bridgeUrl}
        />
      )}
      {showReach360ErrorDialog && (
        <TrainWithReach360ErrorDialog
          onRequestClose={() => setShowReach360ErrorDialog(false)}
        />
      )}
      <NavItem
        href={href}
        onClick={onClick}
        target={href && '_blank'}
        title={t('productNames.reach360')}
      />
    </>
  )
}

export default function NavLite(): JSX.Element {
  const [t] = useTranslation()
  const userSubStatus = useContext(SubContext)
  const authContext = useContext(AuthContext)
  const { riseCom360Upsell } = useFlags()

  if (authContext.self.loading) {
    return null
  }

  if (!isLoggedIn(authContext.self)) {
    return (
      <div className="header__nav">
        <a
          className="header__nav_logo"
          style={{ backgroundImage: logoBackground }}
          href={`${process.env.THREESIXTY_FRONTEND_URI}`}>
          Articulate - 360
        </a>
      </div>
    )
  }

  return (
    <div className="header__nav">
      <div className="header__nav_logo" style={{ backgroundImage: logoBackground }}>
          Articulate - 360
      </div>
      <NavItem href={`${process.env.THREESIXTY_FRONTEND_URI}`} title="Dashboard" />
      <NavItem
        href={`${process.env.THREESIXTY_FRONTEND_URI}/rise`}
        disabled={!isRiseEnabled(userSubStatus)}
        title={t('productNames.rise')}
      />
      <NavItem
        href={`${process.env.THREESIXTY_FRONTEND_URI}/review`}
        disabled={!isReviewEnabled(userSubStatus)}
        title={t('productNames.review')}
      />
      {riseCom360Upsell && <NavItemReach360/>}
      <NavItem isActive title={t('productNames.training')} />
    </div>
  )
}
